// Unpublished Work © 2021-2022 Deere & Company

import {isFeatureToggled} from './feature-toggles';

const defaultCountry = 'US';

const isCountryInCountryList = (countryCode, countries) => {
    const countryCodes = countries.map((country) => country.key);

    return countryCodes.includes(countryCode);
};

export const adaptDomainData = (domainData) => {
    const selectedCountry = isCountryInCountryList(domainData.selectedValues.country, domainData.countries) ?
        domainData.selectedValues.country :
        defaultCountry;

    return {
        ...domainData,
        selectedValues: {
            ...domainData.selectedValues,
            country: selectedCountry
        }
    };
};

export const filterCountryList = (countries, countriesFromParentApp) => {
    if (countriesFromParentApp.length !== 0) {
        return countries.filter((country) => countriesFromParentApp.includes(country.key));
    }
    return countries;
};

export const adaptSearchPreferences = (searchPreferences, countries) => {
    if (isCountryInCountryList(searchPreferences.countryCode, countries)) {
        return searchPreferences;
    }

    return {
        countryCode: defaultCountry,
        stateCodes: []
    };
};

export const isCitiesDropdownFacetVisible = (cityAsDropdown = false) => isFeatureToggled('SHOW_CITY_DROPDOWN_FACET') && cityAsDropdown;
export const isCitiesDropdownAddEditVisible = (cityAsDropdown = false) => isFeatureToggled('F10734_US58064_CITY_DROPDOWN_ADD_EDIT_PAGE') && cityAsDropdown;
